import React from 'react';

import css from './Loader.module.scss';

const Loader = () => (
  <div className={css.overlay} data-e2e="loading-screen" data-testid="loader">
    <div className={css.centered}>
      <img
        className={css.logo}
        src={`/static/loading-screen.gif`}
        alt={`Greenlight Loading`}
      />
    </div>
  </div>
);

export default Loader;
